'use client';
import styled from 'styled-components';

export const FormFieldsContainer = styled.div`
  align-items: center;
  color: ${props => props.theme.colors.text.secondary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: ${props => (props.$maxWidth ? `${props.$maxWidth}px` : 'none')};
`;
